export default __webpack_public_path__ + "static/media/custom_fields.11e0e390.png";